import React from "react";
import LogoMark from "@/components/LogoMark";

export default function PageLoader({ show }) {
  return (
    <div
      data-testid="page-loader"
      aria-hidden={!show}
      className={`fixed inset-0 z-[200] bg-[#0A0A0A] flex items-center justify-center transition-opacity duration-500 ${
        show ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex flex-col items-center gap-7">
        <div className="hs-loader-mark">
          <LogoMark className="h-16 w-auto" />
        </div>
        <div className="hs-loader-bar" />
      </div>
      <style>{`
        @keyframes hsFloat {0%,100%{transform:translateY(0) scale(1);}50%{transform:translateY(-7px) scale(1.05);}}
        @keyframes hsSlide {0%{background-position:200% 0;}100%{background-position:-200% 0;}}
        .hs-loader-mark{animation:hsFloat 1.4s ease-in-out infinite;filter:drop-shadow(0 0 26px rgba(188,93,46,.4));}
        .hs-loader-bar{width:130px;height:2px;background:linear-gradient(90deg,transparent,#BC5D2E,transparent);background-size:200% 100%;animation:hsSlide 1.1s linear infinite;}
      `}</style>
    </div>
  );
}
